import mitt from 'mitt';

export const Events = mitt();
